import { Injectable } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FireSubService {
    private subscriptionParent: Subscription;
    private unsubSubject: Subject<void> = new Subject<void>();

    constructor () {
        this.subscriptionParent = new Subscription();
    }

    registerSubscription(sub: Subscription) {
        this.subscriptionParent.add(sub);
    }

    unsubscribeAllSubs() {
        this.subscriptionParent.unsubscribe();
        this.subscriptionParent = new Subscription();
        this.unsubSubject.next();
    }

    get unsubscriber() {
        return this.unsubSubject;
    }
}